import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../shared/global';

@Injectable()
export class DashboardService {

	private baseApiUrlTest=GlobalVariable.BASE_API_URL;
	private headers = new Headers({'Content-Type': 'application/json'});
	private get_account_url = this.baseApiUrlTest + 'api/Account/get/account';
	private get_auto_pay = this.baseApiUrlTest + 'api/autopay/details/dashboard';
	private get_card = this.baseApiUrlTest + 'api/ManageCard/get/card/detail';

	constructor(private http: Http) { }

	getAccountDetail(token: Object): Promise<any> {
		return this.http.post(this.get_account_url, token)
	           .toPromise()
	           .then(response => response.json())
	           .catch(this.handleError);
	}

	getAutoPay(data: string) {
		return this.http
		.get(this.get_auto_pay + '?token=' + data)
		.toPromise()
		.then(res => res.json())
		.catch(this.handleError);
  	}

	getCard(token: Object) {
      return this.http
        .post(this.get_card, token)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  	}

	private handleError(error: any): Promise<any> {
	    console.error('An error occurred', error);
	    return Promise.reject(error.message || error);
	}

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.service.ts